<template>
  <div class="flex w-screen">
    <Dialog modal :visible="showDialog" header="Configurações" :pt="{
      root: {
        style: {
          border: 'none',
          width: '90vw',
        },
      },
      mask: {
        style: 'backdrop-filter: blur(2px)',
      },
    }" @update:visible="atualizarVisibilidade">
      <Card class="surface-200">
        <template #content>
          <div class="flex flex-row align-items-center justify-content-between">
            Ativar/Desativar ping
            <InputSwitch v-model="deviceStore.doPing" :invalid="!deviceStore.doPing" />
          </div>
        </template>
      </Card>
      <Card class="surface-200 mt-2">
        <template #content>
          <div class="flex flex-row align-items-center justify-content-between">
            Desativar teclado
            <InputSwitch v-model="deviceStore.desativarTeclado" />
          </div>
        </template>
      </Card>
      <!-- <Card v-if="config.public.DEV" class="surface-200 mt-2">
        <template #content>
          <div class="flex flex-row align-items-center justify-content-between">
            Ativar animações
            <InputSwitch v-model="deviceStore.enableAnimations" />
          </div>
        </template>
      </Card>
      <Card v-if="config.public.DEV" class="surface-200 mt-2">
        <template #content>
          <div class="flex flex-row align-items-center justify-content-between">
            Habilitar debug
            <InputSwitch v-model="deviceStore.debugSettings.enableDebug" />
          </div>

          <div v-if="config.public.DEV && deviceStore.debugSettings.enableDebug" class="w-full mt-2">
            <R3Input v-model:input-value="deviceStore.debugSettings.AccessNumber" />
            <Button class="w-full mt-2" @click="habilitarDebug">
              Habilitar
            </Button>
          </div>
        </template>
      </Card>
      <div v-if="config.public.DEV" class="flex mt-2 text-center justify-content-center align-items-center">
        <Button class="w-full" @click="alterarVisiblidadeModalEstilizacao">
          Estilização
        </Button>
        <span v-if="modalEstilizacao">
          <LazyModalStyleSettings v-model:visible="modalEstilizacao" />
        </span>
      </div> -->
    </Dialog>
  </div>
</template>

<script setup lang="ts">
const showDialog = defineModel<boolean>("show");

const toast = useToast();
const config = useRuntimeConfig();
// vue

// stores
const deviceStore = useDeviceStore();

// lifecyle

// Refs
const debugServerIP = ref("");
const debugServerPort = ref<number>();

// Modal estilizacao
const modalEstilizacao = ref<boolean>(false);
function alterarVisiblidadeModalEstilizacao() {
  modalEstilizacao.value = !modalEstilizacao.value;
}

// funcoes

function atualizarVisibilidade(params: boolean) {
  showDialog.value = params;
}

function habilitarDebug() {
  if (deviceStore.debugSettings.connected === false) {
    toast.add({ severity: "error", summary: "Erro", detail: "Debug não conectado", life: 1000 });
  }
  else {
    const newDebugSetting = {
      ...deviceStore.debugSettings,
      enableDebug: true
    }
    deviceStore.setDebugSettings(newDebugSetting);
    toast.add({ severity: "success", summary: "Sucesso", detail: "Debug habilitado", life: 1000 });
  }
}
</script>
